import React from 'react';
import { Box, Container, Grid, Typography, Button, Stack, Paper } from '@mui/material';
import { images } from '../assets/images';
import { glance } from '../data';
import { Img } from './common';

const Hero = () => (
  <>
    <Box component="section" id="home" sx={{ bgcolor: 'primary.dark', color: '#fff', pt: { xs: 8, md: 10 }, pb: { xs: 18, md: 22 }, overflow: 'hidden' }}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 8, md: 8 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h1" sx={{ fontSize: { xs: '2.8rem', md: '4.2rem' }, lineHeight: 1.02, mb: 3 }}>
              Learn to help people move again.
            </Typography>
            <Typography sx={{ fontSize: '1.15rem', lineHeight: 1.75, color: 'rgba(255,255,255,0.8)', maxWidth: 520, mb: 4 }}>
              The Bachelor of Physiotherapy at Shree Bhavani Group of Institutions, Bangalore, combines classroom learning, laboratory training and a six-month hospital internship.
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <Button href="#admission" variant="contained" color="secondary" size="large">Apply for admission</Button>
              <Button href="#curriculum" variant="outlined" size="large" sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.5)', '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.08)' } }}>
                View curriculum
              </Button>
            </Stack>
            <Box sx={{ mt: 5, p: 2.5, maxWidth: 520, borderLeft: '4px solid', borderColor: 'secondary.main', bgcolor: 'rgba(255,255,255,0.07)' }}>
              <Typography sx={{ fontWeight: 700, mb: 0.5 }}>Merit-based fee concession</Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.6 }}>
                ₹50,000 for 80% and above in 12th / PUC. ₹25,000 for 70% and above.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ position: 'relative', pb: { xs: 6, md: 8 } }}>
              <Box sx={{ width: '84%', ml: 'auto', aspectRatio: '4 / 5', borderRadius: '999px 999px 12px 12px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.2)' }}>
                <Img src={images.hero} alt="Shree Bhavani Group of Institutions building with Padma Devaiah Multi-Speciality Hospital" />
              </Box>
              <Box sx={{ position: 'absolute', left: 0, bottom: 0, width: { xs: '46%', md: '44%' }, aspectRatio: '1 / 1', borderRadius: '12px', overflow: 'hidden', border: '6px solid', borderColor: 'primary.dark', boxShadow: '0 0 0 2px #F2A93B' }}>
                <Img src={images.heroSecondary} alt="Physiotherapy lab equipment" />
              </Box>
              <Paper elevation={0} sx={{ position: 'absolute', top: { xs: '6%', md: '10%' }, left: 0, p: 2, maxWidth: 210, borderRadius: '8px' }}>
                <Typography variant="h6" sx={{ color: 'primary.dark', fontSize: '1rem', lineHeight: 1.2 }}>Supervised hospital postings</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem', mt: 0.5 }}>Clinical exposure from the early years.</Typography>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>

    <Container maxWidth="lg" sx={{ mt: { xs: -10, md: -11 }, position: 'relative', zIndex: 2 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: '12px', border: '1px solid', borderColor: 'divider', boxShadow: '0 24px 48px rgba(11,46,53,0.12)' }}>
        <Grid container spacing={3}>
          {glance.map(([label, value]) => (
            <Grid item xs={6} md={2.4} key={label}>
              <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem', mb: 0.5 }}>{label}</Typography>
              <Typography sx={{ fontWeight: 700, color: 'primary.dark', lineHeight: 1.35 }}>{value}</Typography>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Container>
  </>
);

export default Hero;
